/** Shared minimalist UI tokens — aligned with portal / Finance Elite / Hear Us. */

export const pageShell =
  'min-h-screen bg-gradient-to-br from-gray-950 via-gray-900 to-gray-950 text-white'

export const panel =
  'rounded-lg border border-white/10 bg-gray-950/95'

export const panelInner =
  'rounded-lg border border-white/10 bg-gray-900/90'

export const modalPanel =
  'rounded-lg border border-white/10 bg-gray-950 shadow-xl'

export const ghostBtn =
  'inline-flex h-8 items-center justify-center gap-1.5 rounded-lg border border-white/10 bg-transparent px-2.5 text-xs text-white/55 transition-colors hover:bg-white/5 hover:text-white/85 disabled:opacity-50'

export const primaryBtn =
  'inline-flex h-9 w-full items-center justify-center gap-1.5 rounded-lg border border-white/15 bg-white/[0.06] px-3 text-xs font-medium text-white/85 transition-colors hover:bg-white/10 disabled:opacity-50'

export const primaryBtnInline =
  'inline-flex h-8 items-center justify-center gap-1.5 rounded-lg border border-white/15 bg-white/[0.06] px-3 text-xs font-medium text-white/85 transition-colors hover:bg-white/10 disabled:opacity-50'

export const fieldClass =
  'h-9 w-full rounded-lg border border-white/10 bg-gray-950 px-3 text-sm text-white placeholder:text-white/30 focus:border-white/20 focus:outline-none [color-scheme:dark]'

export const selectClass =
  'h-9 w-full rounded-lg border border-white/10 bg-gray-950 px-3 text-sm text-white focus:border-white/20 focus:outline-none [color-scheme:dark]'

export const labelClass = 'mb-1.5 block text-[11px] font-medium text-white/45'

export const headingClass = 'text-base font-semibold text-white/90 sm:text-lg'

export const mutedClass = 'text-xs text-white/45 sm:text-sm'

export const errorBox =
  'rounded-lg border border-red-500/20 bg-red-500/5 px-3 py-2 text-xs text-red-300/90'

export const successBox =
  'rounded-lg border border-emerald-500/20 bg-emerald-500/5 px-3 py-2 text-xs text-emerald-300/90'
